import { render, staticRenderFns } from "./Acoes.vue?vue&type=template&id=bdd41664"
import script from "./Acoes.vue?vue&type=script&lang=js"
export * from "./Acoes.vue?vue&type=script&lang=js"
import style0 from "./Acoes.vue?vue&type=style&index=0&id=bdd41664&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports